import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _typeof from '@babel/runtime-corejs3/helpers/typeof';
import _padStartInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/pad-start';
import { c as clsx } from '../clsx.m-7e9a4a81.js';
import React__default, { useContext, useState, useMemo } from 'react';
import { useEventCallback } from '@thimble/utility';
import { T as Typography } from '../Typography-b5ab7944.js';
import '@babel/runtime-corejs3/core-js-stable/array/is-array';
import '@babel/runtime-corejs3/core-js-stable/object/keys';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import '@babel/runtime-corejs3/core-js-stable/instance/filter';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import '@babel/runtime-corejs3/core-js-stable/object/define-property';
import '@babel/runtime-corejs3/helpers/defineProperty';
import '@babel/runtime-corejs3/helpers/objectWithoutProperties';

var Text = Typography.Text;
var uuid = 0;
var RadioContext = /*#__PURE__*/React__default.createContext({
  value: undefined,
  name: '',
  onChange: function onChange() {}
});

var noop = function noop() {};

var RadioAtom = function RadioAtom(_ref) {
  var checked = _ref.checked,
      disabled = _ref.disabled;
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx('smb-radio__sharp', checked && 'smb-radio__sharp--checked', disabled && 'smb-radio__sharp--disabled')
  });
};

var Radio = function Radio(_ref2) {
  var value = _ref2.value,
      disabled = _ref2.disabled,
      children = _ref2.children,
      label = _ref2.label;

  var _useContext = useContext(RadioContext),
      radioGroupValue = _useContext.value,
      name = _useContext.name,
      _onChange = _useContext.onChange;

  var checked = radioGroupValue === value;
  var color = disabled ? 'light-grey' : !checked ? 'dark-grey' : 'black';
  var labelNode = _typeof(label) !== undefined ? /*#__PURE__*/React__default.createElement(Text, {
    preset: "h5",
    color: color
  }, label) : null;
  var sharpNode = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("input", {
    type: "radio",
    checked: checked,
    disabled: disabled,
    onChange: function onChange() {
      return !checked && _onChange(value);
    },
    name: name
  }), /*#__PURE__*/React__default.createElement(RadioAtom, {
    checked: checked,
    disabled: disabled
  }));
  return /*#__PURE__*/React__default.createElement("label", {
    className: clsx('smb-radio', checked && 'smb-radio--checked', disabled && 'smb-radio--disabled')
  }, typeof children === 'function' ? children({
    sharp: sharpNode,
    label: labelNode,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    checked: checked,
    color: color
  }) : /*#__PURE__*/React__default.createElement(RadioInner, null, sharpNode, labelNode));
}; // eslint-disable-next-line @typescript-eslint/no-explicit-any


var RadioGroup = function RadioGroup(_ref3) {
  var _name = _ref3.name,
      children = _ref3.children,
      value = _ref3.value,
      _ref3$type = _ref3.type,
      type = _ref3$type === void 0 ? 'default' : _ref3$type,
      _ref3$onChange = _ref3.onChange,
      onChange = _ref3$onChange === void 0 ? noop : _ref3$onChange;

  var _useState = useState(function () {
    return _name || 'anonymous_' + ++uuid;
  }),
      _useState2 = _slicedToArray(_useState, 1),
      name = _useState2[0];

  var onChangeEc = useEventCallback(onChange);
  var radioContextValue = useMemo(function () {
    return {
      name: name,
      value: value,
      onChange: onChangeEc
    };
  }, [name, value, onChangeEc]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx('smb-radio-group', type === 'block' ? 'smb-radio-group--block' : 'smb-radio-group--default')
  }, /*#__PURE__*/React__default.createElement(RadioContext.Provider, {
    value: radioContextValue
  }, children));
};

var RadioInner = function RadioInner(_ref4) {
  var children = _ref4.children,
      padStart = _padStartInstanceProperty(_ref4);

  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx('smb-radio__inner', padStart && 'smb-radio__inner--pad-start')
  }, children);
};

Radio.Group = RadioGroup;
Radio.Inner = RadioInner;
Radio.Atom = RadioAtom;

export default Radio;
